export const deviceOptions = [
  { value: JSON.stringify({ model: '', subType: '' }), label: '전체' },
  {
    value: JSON.stringify({ model: 'DT000001', subType: '' }),
    label: 'MODLINK-T',
  },
  {
    value: JSON.stringify({ model: 'DT000003', subType: '' }),
    label: 'MB10 (구 MODLINK-B)',
  },
  {
    value: JSON.stringify({ model: 'DT000004', subType: '' }),
    label: 'MODLINK-L',
  },
  {
    value: JSON.stringify({ model: 'DT000002', subType: '' }),
    label: 'MT10 (구 MODLINK-T2)',
  },
  {
    value: JSON.stringify({ model: 'DT000006', subType: '' }),
    label: 'MT11',
  },
  {
    value: JSON.stringify({ model: 'DT000006', subType: 'DS200004' }),
    label: 'MT11-G',
  },
  {
    value: JSON.stringify({ model: 'DT000002', subType: 'DS200003' }),
    label: 'MR10 (구MODLINK-T3)',
  },
  {
    value: JSON.stringify({ model: 'DT000009', subType: 'DS200005' }),
    label: 'MR20-KR',
  },
  {
    value: JSON.stringify({ model: 'DT000009', subType: 'DS200006' }),
    label: 'MR20-G',
  },
  { value: JSON.stringify({ model: 'DT000005', subType: '' }), label: 'ML10' },
  {
    value: JSON.stringify({ model: 'DT200001', subType: '' }),
    label: 'RP10-2(RELAYPOINT-P2)',
  },
  {
    value: JSON.stringify({ model: 'DT200002', subType: '' }),
    label: 'RP10-4(RELAYPOINT-P4)',
  },
  {
    value: JSON.stringify({ model: 'DT000007', subType: '' }),
    label: 'ML10-BM5',
  },
  {
    value: JSON.stringify({ model: 'DT000008', subType: '' }),
    label: 'MT11-BM5',
  },
];

export const MCUOptions = [
  { value: 'MT000001', label: 'MCU 1' },
  { value: 'MT000002', label: 'MCU 2' },
];
export const getSelectValue = (modelFilter: string, subTypeFilter: string) => {
  return JSON.stringify({ model: modelFilter, subType: subTypeFilter });
};

export const solutionOptions = [
  { value: 'ST100002', label: 'PROGIX' },
  { value: 'ST100003', label: 'SCAUTR' },
];

export const getSolution = (value: string): string => {
  const solution = solutionOptions.find((option) => option.value === value);
  return solution?.label || '';
};

export const noticeTypeOptions = [
  { value: 'NT100001', label: '공지사항' },
  { value: 'NT100002', label: '업데이트' },
  { value: 'NT100003', label: '이벤트' },
];

export const getNoticeType = (value: string): string => {
  const noticeType = noticeTypeOptions.find((option) => option.value === value);
  return noticeType?.label || '';
};

export const languageOptions = [
  { value: 'LT100001', label: '영어' },
  { value: 'LT100002', label: '한국어' },
  { value: 'LT100003', label: '일본어' },
];

export const getLanguage = (value: string): string => {
  const language = languageOptions.find((option) => option.value === value);
  return language?.label || '';
};
